import { render, staticRenderFns } from "./ConfirmacaoExclusao.vue?vue&type=template&id=bc478edc"
import script from "./ConfirmacaoExclusao.vue?vue&type=script&lang=js"
export * from "./ConfirmacaoExclusao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports